import { useEffect } from 'react';

const usePreconnectToUrl = ({ url, id }: { id: string; url: string }) => {
  const preconnect = () => {
    if (url) {
      const preconnectToServerLink = document.getElementById(id);
      if (!preconnectToServerLink) {
        const link = document.createElement('link');
        link.href = url;
        link.rel = 'preconnect';
        link.id = id;
        document.body.appendChild(link);
      }
    }
  };

  useEffect(() => {
    preconnect();
  }, []);

  return { preconnect };
};

export default usePreconnectToUrl;
